import {TIMEZONE_ACTIONS} from "../actions/types";

export default (state = [], {type, list}) => {
	switch(type) {
		case TIMEZONE_ACTIONS.LOAD:
			return list;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/timezoneReducer.js